module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./n3MultipleInputDocs.md");


//////////////////
// WEBPACK FOOTER
// ./docs/example_zh/n3MultipleInputDocs.md
// module id = 1023
// module chunks = 0